import axios from "axios";
import styles from "./FaqEdit.module.css";
import { API } from "../../config";
import { useState, useEffect } from "react";
import Spinner from "../Spinner/Spinner";
import Popup from "../Popup/Popup";
import { useNavigate, useParams } from "react-router-dom";
import { DeleteConfirmation } from "./DeleteConfirmation";

export const FaqEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [spin, setSpin] = useState(true);
  const [spinn, setSpinn] = useState(false);
  const [show, setShow] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [errors, setErrors] = useState({});
  const [faq, setFaq] = useState({
    question: "",
    answer: "",
  });

  const change = () => {
    setShow(false);
  };

  const getData = async () => {
    try {
      const response = await axios.get(`${API}/Admin/faqs/${id}`);
      const faqData = response.data.faq || response.data;
      setFaq({
        question: faqData.question || "",
        answer: faqData.answer || "",
      });
      setSpin(false);
    } catch (error) {
      console.log(error);
      setSpin(false);
    }
  };

  useEffect(() => {
    getData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFaq({ ...faq, [name]: value });
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!faq.question.trim()) {
      newErrors.question = "Question is required";
    } else if (faq.question.trim().length < 5) {
      newErrors.question = "Question must be at least 5 characters";
    }

    if (!faq.answer.trim()) {
      newErrors.answer = "Answer is required";
    } else if (faq.answer.trim().length < 10) {
      newErrors.answer = "Answer must be at least 10 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    window.scrollTo(0, 0);
    setSpinn(true);

    try {
      const response = await axios.put(`${API}/Admin/faqs/${id}`, faq);
      console.log(response);
      setShow(true);
      setSpinn(false);
      setTimeout(() => {
        navigate(-1);
      }, 1500);
    } catch (error) {
      console.log(error);
      setErrors({
        submit:
          error.response?.data?.message ||
          "Failed to update FAQ. Please try again.",
      });
      setSpinn(false);
    }
  };

  const handleCancelDeleteConfirmation = () => {
    setShowDeleteConfirmation(false);
  };

  const handleConfirmDeleteConfirmation = async () => {
    try {
      setSpinn(true);
      await axios.delete(`${API}/Admin/faqs/${id}`);
      setShowDeleteConfirmation(false);
      setSpinn(false);
      navigate(-1);
    } catch (error) {
      console.log(error);
      setErrors({
        submit:
          error.response?.data?.message ||
          "Failed to delete FAQ. Please try again.",
      });
      setSpinn(false);
      setShowDeleteConfirmation(false);
    }
  };

  return (
    <>
      {spinn ? <Spinner /> : null}
      {spin ? (
        <Spinner />
      ) : (
        <>
          {show ? (
            <Popup
              show={show}
              switch={change}
              message="FAQ Updated Successfully"
            />
          ) : null}
          <DeleteConfirmation
            show={showDeleteConfirmation}
            handleCancel={handleCancelDeleteConfirmation}
            handleConfirm={handleConfirmDeleteConfirmation}
          />
          <div className={styles.clientpage}>
            <div className={styles.heading}>
              <h1 className={styles.details}>Edit FAQ</h1>
              <form onSubmit={handleSubmit}>
                <div className={styles.items}>
                  <div className={styles.second}>
                    <p>Enter the Question</p>
                    <input
                      name="question"
                      placeholder="Enter the question"
                      type="text"
                      value={faq.question}
                      onChange={handleChange}
                      id={styles.gap}
                      required
                    />
                    {errors.question && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "14px",
                          marginTop: "8px",
                          marginBottom: "8px",
                        }}
                      >
                        {errors.question}
                      </div>
                    )}
                  </div>

                  <div className={styles.second}>
                    <p>Enter the Answer</p>
                    <textarea
                      name="answer"
                      placeholder="Enter the answer"
                      value={faq.answer}
                      onChange={handleChange}
                      id={styles.textarea}
                      required
                      rows={6}
                    />
                    {errors.answer && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "14px",
                          marginTop: "8px",
                          marginBottom: "8px",
                        }}
                      >
                        {errors.answer}
                      </div>
                    )}
                  </div>

                  {errors.submit && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "8px",
                        marginBottom: "8px",
                      }}
                    >
                      {errors.submit}
                    </div>
                  )}

                  <div className={styles.button}>
                    <input
                      type="submit"
                      className={styles.bttn}
                      style={{ marginRight: "24px" }}
                      value="Update"
                    />
                    <input
                      type="button"
                      className={styles.bttn}
                      onClick={() => setShowDeleteConfirmation(true)}
                      value="Delete"
                      style={{
                        backgroundColor: "#fff",
                        color: "#e53935",
                        borderColor: "#e53935",
                      }}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </>
      )}
    </>
  );
};
